import { Box, SxProps, Theme } from '@mui/material'
import { ID } from '../../types/models'
import { value } from './util'

export type InfoListLines<Type> = Record<string, string | ((t: Type) => string | React.ReactElement)>

export interface InfoListProps<Type> {
  item: Type | null
  lines: InfoListLines<Type>
  sx?: SxProps<Theme>
}

export function InfoList<Type extends { id?: ID }>(props: InfoListProps<Type>): React.ReactElement {
  const { item, lines, sx } = props

  return (
    <Box sx={sx}>
      {Object.keys(lines).map(title => {
        return <Box key={title}>
          <Box color="secondary.main">{title}</Box>
          <Box sx={{ ml: 2, height: 30 }}>{value(lines[title], item)}&nbsp;</Box>
        </Box>
      })}
    </Box>
  )
}
